import G from "../../../../../../async-validator@4.2.5/node_modules/async-validator/dist-web/index.js";
import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { formItemInjectionKey as de } from "../../_mixins/use-form-item.js";
import { formItemInstsInjectionKey as ce, formInjectionKey as fe } from "./context.js";
import me from "./styles/form-item.cssr.js";
import { formItemSize as ue, formItemMisc as ge, formItemRule as be } from "./utils.js";
import { useInjectionInstanceCollection as he } from "../../_utils/composable/use-collection.js";
import ve from "../../_mixins/use-config.js";
import { createId as J } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/misc/index.js";
import Z from "../../_mixins/use-theme.js";
import { createKey as _ } from "../../_utils/cssr/index.js";
import { useThemeClass as ke } from "../../_mixins/use-css-vars-class.js";
import { resolveWrappedSlot as pe } from "../../_utils/vue/resolve-slot.js";
import ye from "../styles/light.js";
import Re from "../../../../../../lodash-es@4.17.21/node_modules/lodash-es/get.js";
import { warn as Q } from "../../_utils/naive/warn.js";
import { defineComponent as Se, inject as we, watch as _e, provide as $e, onMounted as Ce, computed as N, h as f } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { toRef as L, ref as B } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { Transition as xe } from "../../../../../../@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
var U = globalThis && globalThis.__awaiter || function(i, e, u, t) {
  function h(s) {
    return s instanceof u ? s : new u(function(k) {
      k(s);
    });
  }
  return new (u || (u = Promise))(function(s, k) {
    function C(l) {
      try {
        b(t.next(l));
      } catch (d) {
        k(d);
      }
    }
    function v(l) {
      try {
        b(t.throw(l));
      } catch (d) {
        k(d);
      }
    }
    function b(l) {
      l.done ? s(l.value) : h(l.value).then(C, v);
    }
    b((t = t.apply(i, e || [])).next());
  });
};
const Pe = Object.assign(Object.assign({}, Z.props), {
  label: String,
  labelWidth: [Number, String],
  labelStyle: [String, Object],
  labelAlign: String,
  labelPlacement: String,
  path: String,
  first: Boolean,
  rulePath: String,
  required: Boolean,
  showRequireMark: {
    type: Boolean,
    default: void 0
  },
  requireMarkPlacement: String,
  showFeedback: {
    type: Boolean,
    default: void 0
  },
  rule: [Object, Array],
  size: String,
  ignorePathChange: Boolean,
  validationStatus: String,
  feedback: String,
  feedbackClass: String,
  feedbackStyle: [String, Object],
  showLabel: {
    type: Boolean,
    default: void 0
  },
  labelProps: Object
});
function X(i, e) {
  return (...u) => {
    try {
      const t = i(...u);
      return !e && (typeof t == "boolean" || t instanceof Error || Array.isArray(t)) || t != null && t.then ? t : (t === void 0 || Q("form-item/validate", `You return a ${typeof t} typed value in the validator method, which is not recommended. Please use ${e ? "`Promise`" : "`boolean`, `Error` or `Promise`"} typed value instead.`), !0);
    } catch (t) {
      Q("form-item/validate", "An error is catched in the validation, so the validation won't be done. Your callback in `validate` method of `n-form` or `n-form-item` won't be called in this validation."), console.error(t);
      return;
    }
  };
}
const Ge = Se({
  name: "FormItem",
  props: Pe,
  setup(i) {
    he(ce, "formItems", L(i, "path"));
    const {
      mergedClsPrefixRef: e,
      inlineThemeDisabled: u
    } = ve(i), t = we(fe, null), h = ue(i), s = ge(i), {
      validationErrored: k,
      validationWarned: C
    } = s, {
      mergedRequired: v,
      mergedRules: b
    } = be(i), {
      mergedSize: l
    } = h, {
      mergedLabelPlacement: d,
      mergedLabelAlign: p,
      mergedRequireMarkPlacement: H
    } = s, j = B([]), K = B(J()), ee = t ? L(t.props, "disabled") : B(!1), te = Z("Form", "-form-item", me, ye, i, e);
    _e(L(i, "path"), () => {
      i.ignorePathChange || E();
    });
    function E() {
      j.value = [], k.value = !1, C.value = !1, i.feedback && (K.value = J());
    }
    const x = (...n) => U(this, [...n], void 0, function* (m = null, y = () => !0, o = {
      suppressWarning: !0
    }) {
      const {
        path: R
      } = i;
      o ? o.first || (o.first = i.first) : o = {};
      const {
        value: $
      } = b, I = t ? Re(t.props.model, R || "") : void 0, M = {}, z = {}, S = (m ? $.filter((a) => Array.isArray(a.trigger) ? a.trigger.includes(m) : a.trigger === m) : $).filter(y).map((a, c) => {
        const r = Object.assign({}, a);
        if (r.validator && (r.validator = X(r.validator, !1)), r.asyncValidator && (r.asyncValidator = X(r.asyncValidator, !0)), r.renderMessage) {
          const F = `__renderMessage__${c}`;
          z[F] = r.message, r.message = F, M[F] = r.renderMessage;
        }
        return r;
      }), w = S.filter((a) => a.level !== "warning"), T = S.filter((a) => a.level === "warning"), g = {
        valid: !0,
        errors: void 0,
        warnings: void 0
      };
      if (!S.length)
        return g;
      const A = R != null ? R : "__n_no_path__", O = new G({
        [A]: w
      }), W = new G({
        [A]: T
      }), {
        validateMessages: V
      } = (t == null ? void 0 : t.props) || {};
      V && (O.messages(V), W.messages(V));
      const q = (a) => {
        j.value = a.map((c) => {
          const r = (c == null ? void 0 : c.message) || "";
          return {
            key: r,
            render: () => r.startsWith("__renderMessage__") ? M[r]() : r
          };
        }), a.forEach((c) => {
          var r;
          !((r = c.message) === null || r === void 0) && r.startsWith("__renderMessage__") && (c.message = z[c.message]);
        });
      };
      if (w.length) {
        const a = yield new Promise((c) => {
          O.validate({
            [A]: I
          }, o, c);
        });
        a != null && a.length && (g.valid = !1, g.errors = a, q(a));
      }
      if (T.length && !g.errors) {
        const a = yield new Promise((c) => {
          W.validate({
            [A]: I
          }, o, c);
        });
        a != null && a.length && (q(a), g.warnings = a);
      }
      return !g.errors && !g.warnings ? E() : (k.value = !!g.errors, C.value = !!g.warnings), g;
    });
    function ae() {
      x("blur");
    }
    function ne() {
      x("change");
    }
    function re() {
      x("focus");
    }
    function ie() {
      x("input");
    }
    function le(n, m) {
      return U(this, void 0, void 0, function* () {
        let y, o, R, $;
        return typeof n == "string" ? (y = n, o = m) : n !== null && typeof n == "object" && (y = n.trigger, o = n.callback, R = n.shouldRuleBeApplied, $ = n.options), yield new Promise((I, M) => {
          x(y, R, $).then(({
            valid: z,
            errors: S,
            warnings: w
          }) => {
            z ? (o && o(void 0, {
              warnings: w
            }), I({
              warnings: w
            })) : (o && o(S, {
              warnings: w
            }), M(S));
          });
        });
      });
    }
    $e(de, {
      path: L(i, "path"),
      disabled: ee,
      mergedSize: h.mergedSize,
      mergedValidationStatus: s.mergedValidationStatus,
      restoreValidation: E,
      handleContentBlur: ae,
      handleContentChange: ne,
      handleContentFocus: re,
      handleContentInput: ie
    });
    const oe = {
      validate: le,
      restoreValidation: E,
      internalValidate: x
    }, D = B(null);
    Ce(() => {
      if (!s.isAutoLabelWidth.value)
        return;
      const n = D.value;
      if (n !== null) {
        const m = n.style.whiteSpace;
        n.style.whiteSpace = "nowrap", n.style.width = "", t == null || t.deriveMaxChildLabelWidth(Number(getComputedStyle(n).width.slice(0, -2))), n.style.whiteSpace = m;
      }
    });
    const Y = N(() => {
      var n;
      const {
        value: m
      } = l, {
        value: y
      } = d, o = y === "top" ? "vertical" : "horizontal", {
        common: {
          cubicBezierEaseInOut: R
        },
        self: {
          labelTextColor: $,
          asteriskColor: I,
          lineHeight: M,
          feedbackTextColor: z,
          feedbackTextColorWarning: S,
          feedbackTextColorError: w,
          feedbackPadding: T,
          labelFontWeight: g,
          [_("labelHeight", m)]: A,
          [_("blankHeight", m)]: O,
          [_("feedbackFontSize", m)]: W,
          [_("feedbackHeight", m)]: V,
          [_("labelPadding", o)]: q,
          [_("labelTextAlign", o)]: a,
          [_(_("labelFontSize", y), m)]: c
        }
      } = te.value;
      let r = (n = p.value) !== null && n !== void 0 ? n : a;
      return y === "top" && (r = r === "right" ? "flex-end" : "flex-start"), {
        "--n-bezier": R,
        "--n-line-height": M,
        "--n-blank-height": O,
        "--n-label-font-size": c,
        "--n-label-text-align": r,
        "--n-label-height": A,
        "--n-label-padding": q,
        "--n-label-font-weight": g,
        "--n-asterisk-color": I,
        "--n-label-text-color": $,
        "--n-feedback-padding": T,
        "--n-feedback-font-size": W,
        "--n-feedback-height": V,
        "--n-feedback-text-color": z,
        "--n-feedback-text-color-warning": S,
        "--n-feedback-text-color-error": w
      };
    }), P = u ? ke("form-item", N(() => {
      var n;
      return `${l.value[0]}${d.value[0]}${((n = p.value) === null || n === void 0 ? void 0 : n[0]) || ""}`;
    }), Y, i) : void 0, se = N(() => d.value === "left" && H.value === "left" && p.value === "left");
    return Object.assign(Object.assign(Object.assign(Object.assign({
      labelElementRef: D,
      mergedClsPrefix: e,
      mergedRequired: v,
      feedbackId: K,
      renderExplains: j,
      reverseColSpace: se
    }, s), h), oe), {
      cssVars: u ? void 0 : Y,
      themeClass: P == null ? void 0 : P.themeClass,
      onRender: P == null ? void 0 : P.onRender
    });
  },
  render() {
    const {
      $slots: i,
      mergedClsPrefix: e,
      mergedShowLabel: u,
      mergedShowRequireMark: t,
      mergedRequireMarkPlacement: h,
      onRender: s
    } = this, k = t !== void 0 ? t : this.mergedRequired;
    s == null || s();
    const C = () => {
      const v = this.$slots.label ? this.$slots.label() : this.label;
      if (!v)
        return null;
      const b = f("span", {
        class: `${e}-form-item-label__text`
      }, v), l = k ? f("span", {
        class: `${e}-form-item-label__asterisk`
      }, h !== "left" ? " *" : "* ") : h === "right-hanging" && f("span", {
        class: `${e}-form-item-label__asterisk-placeholder`
      }, " *"), {
        labelProps: d
      } = this;
      return f("label", Object.assign({}, d, {
        class: [d == null ? void 0 : d.class, `${e}-form-item-label`, `${e}-form-item-label--${h}-mark`, this.reverseColSpace && `${e}-form-item-label--reverse-columns-space`],
        style: this.mergedLabelStyle,
        ref: "labelElementRef"
      }), h === "left" ? [l, b] : [b, l]);
    };
    return f("div", {
      class: [`${e}-form-item`, this.themeClass, `${e}-form-item--${this.mergedSize}-size`, `${e}-form-item--${this.mergedLabelPlacement}-labelled`, this.isAutoLabelWidth && `${e}-form-item--auto-label-width`, !u && `${e}-form-item--no-label`],
      style: this.cssVars
    }, u && C(), f("div", {
      class: [`${e}-form-item-blank`, this.mergedValidationStatus && `${e}-form-item-blank--${this.mergedValidationStatus}`]
    }, i), this.mergedShowFeedback ? f("div", {
      key: this.feedbackId,
      style: this.feedbackStyle,
      class: [`${e}-form-item-feedback-wrapper`, this.feedbackClass]
    }, f(xe, {
      name: "fade-down-transition",
      mode: "out-in"
    }, {
      default: () => {
        const {
          mergedValidationStatus: v
        } = this;
        return pe(i.feedback, (b) => {
          var l;
          const {
            feedback: d
          } = this, p = b || d ? f("div", {
            key: "__feedback__",
            class: `${e}-form-item-feedback__line`
          }, b || d) : this.renderExplains.length ? (l = this.renderExplains) === null || l === void 0 ? void 0 : l.map(({
            key: H,
            render: j
          }) => f("div", {
            key: H,
            class: `${e}-form-item-feedback__line`
          }, j())) : null;
          return p ? v === "warning" ? f("div", {
            key: "controlled-warning",
            class: `${e}-form-item-feedback ${e}-form-item-feedback--warning`
          }, p) : v === "error" ? f("div", {
            key: "controlled-error",
            class: `${e}-form-item-feedback ${e}-form-item-feedback--error`
          }, p) : v === "success" ? f("div", {
            key: "controlled-success",
            class: `${e}-form-item-feedback ${e}-form-item-feedback--success`
          }, p) : f("div", {
            key: "controlled-default",
            class: `${e}-form-item-feedback`
          }, p) : null;
        });
      }
    })) : null);
  }
});
export {
  Ge as default,
  Pe as formItemProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/form/src/FormItem.js
// module id = 61
// module chunks = 67